// extracted by mini-css-extract-plugin
module.exports = {"katexText":"KatexText_katexText__1hvvU"};